import React from 'react';
import { Bugsnag } from '../monitoring/bugsnag';

export function lazyWithRetry<T extends React.ComponentType<any>>(
    factory: () => Promise<{ default: T }>
) {
    return React.lazy(async () => {
        try {
            return await factory();
        } catch (err: any) {
            const msg = String(err?.message || err || '');
            const isChunkFail =
                msg.includes('Failed to fetch dynamically imported module') ||
                msg.includes('Importing a module script failed') ||
                msg.includes('Loading chunk') ||
                msg.includes('dynamically imported module') ||
                msg.includes('Load failed');
            try { Bugsnag?.notify?.(err); } catch { }
            if (isChunkFail) setTimeout(() => window.location.reload(), 100);
            throw err;
        }
    });
}